export function setCookie(
  cName: string,
  cValue: string,
  cDay: number,
  cMin = 0
) {
  const expire = new Date();
  expire.setDate(expire.getDate() + cDay);
  expire.setTime(expire.getTime() + 1000 * 60 * cMin);
  // 한글 깨짐을 막기위해 escape(cValue)를 한다.
  let cookies = `${cName}=${escape(
    cValue
  )}; path=/;domain=${window.location.host.replace("app.", "")}`;
  if (window.location.host.includes("localhost")) {
    cookies = `${cName}=${escape(cValue)}`; // 한글 깨짐을 막기위해 escape(cValue)를 한다.
  }
  if (typeof cDay !== "undefined")
    cookies += `;expires=${expire.toUTCString()};`;
  document.cookie = cookies;
}

export function getCookie(cName: string) {
  if (typeof document === "undefined") return null;
  cName += "=";
  const cookieData = document.cookie;
  let start = cookieData.indexOf(cName);
  let cValue = "";
  if (start !== -1) {
    start += cName.length;
    let end = cookieData.indexOf(";", start);
    if (end === -1) end = cookieData.length;
    cValue = cookieData.substring(start, end);
  }
  return unescape(cValue);
}

export const COOKIE_NAMES = {
  EXCHANGE_TOKEN: "exchange",
  ACCESS_TOKEN: "access",
  WORKSPACE_EIDS: "additor_weids",
  LATEST_WORKSPACE: "latest_ws", // workspace 에 진입 가능한 유저가 랜딩에 진입했을 떄, 바로 이동시켜 줄 workspace eid
  LATEST_PROJECT_ID_FOR_PROJECT_USER: "latest_project_id_for_project_user", // project guest 가 랜딩에 진입했을 때, 바로 이동시켜 줄 project id
};
